module.exports = __webpack_public_path__ + "img/img-3.167ba483.webp";